import * as React from "react";
import Errors from "@/ReactComponents/Errors/errors";

const ErrorsView = props => <Errors {...props} />;

export default ErrorsView;
